module.exports = __webpack_public_path__ + "assets/RetinaNarr-Black.ff0ab0358e904f590efd691aab86977c.woff2";